"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DatePicker = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var kendo_react_dateinputs_1 = require("@progress/kendo-react-dateinputs");
var __1 = require("../");
var utilities_1 = require("../../utilities");
var InputDateMask_1 = require("./InputDateMask");
exports.DatePicker = react_1.default.forwardRef(function (props, ref) {
    var _a;
    var disabled = props.disabled, error = props.error, maskChar = props.maskChar, maskProps = props.maskProps, maxDate = props.maxDate, minDate = props.minDate, onChange = props.onChange, placeholder = props.placeholder, size = props.size, value = props.value, CustomCalendar = props.calendar, _b = props.direction, direction = _b === void 0 ? 'br' : _b, open = props.open, rest = __rest(props, ["disabled", "error", "maskChar", "maskProps", "maxDate", "minDate", "onChange", "placeholder", "size", "value", "calendar", "direction", "open"]);
    var calendarRef = react_1.default.useRef(null);
    var inputRef = react_1.default.useRef(null);
    var _c = react_1.default.useState(open), showCalendar = _c[0], setShowCalendar = _c[1];
    var _d = react_1.default.useState(false), focusCalendar = _d[0], setFocusCalendar = _d[1];
    // Keeping this incase we need to also pass calendar to ref
    /**
     * React.useImperativeHandle(ref, () => ({
     * input: inputRef.current,
     * calendar: calendarRef.current,
     * }));
     */
    var handleClickOutside = function () {
        if (showCalendar) {
            setShowCalendar(false);
            inputRef.current.focus();
        }
    };
    var handleClickIcon = function () { return setShowCalendar(!showCalendar); };
    var handleInputClick = function (event) {
        event.preventDefault();
        setShowCalendar(true);
        inputRef.current.focus();
    };
    var handleKeyDown = function (event) {
        var key = event.key;
        if (key === utilities_1.keys.esc) {
            event.preventDefault();
            setShowCalendar(false);
            inputRef.current.focus();
        }
        if ([utilities_1.keys.space, utilities_1.keys.down].includes(key)) {
            event.preventDefault();
            setShowCalendar(true);
            setFocusCalendar(true);
        }
        if (showCalendar && key === utilities_1.keys.tab) {
            setShowCalendar(false);
        }
    };
    react_1.default.useEffect(function () {
        var _a;
        if (focusCalendar) {
            (_a = calendarRef === null || calendarRef === void 0 ? void 0 : calendarRef.current) === null || _a === void 0 ? void 0 : _a.focus();
            setFocusCalendar(false);
        }
    }, [focusCalendar]);
    react_1.default.useEffect(function () {
        setShowCalendar(open);
    }, [open]);
    var handleChange = function (event) {
        var eventValue = event.target.value;
        var value = eventValue ? eventValue : undefined;
        onChange(value);
        setShowCalendar(false);
        inputRef.current.focus();
    };
    var DatePickerClasses = classnames_1.default('DatePicker', (_a = {
            'DatePicker--disabled': disabled
        },
        _a["DatePicker--" + size] = size,
        _a));
    var InputProps = __assign({ disabled: disabled,
        error: error,
        maskChar: maskChar,
        maxDate: maxDate,
        minDate: minDate,
        onChange: onChange,
        placeholder: placeholder,
        size: size,
        value: value }, maskProps);
    var CalendarProps = {
        value: value,
        max: maxDate,
        min: minDate,
        onChange: handleChange,
        ref: calendarRef,
        tabIndex: -1,
    };
    return (react_1.default.createElement(__1.Popover, __assign({ portal: true, wrapperClassName: DatePickerClasses, open: showCalendar, popoverContentClassName: "DatePicker__calendar", onKeyDown: handleKeyDown, direction: direction, padding: null, width: "auto", ref: ref, onClickOutside: function () { return handleClickOutside(); }, trigger: react_1.default.createElement(InputDateMask_1.InputDateMask, __assign({}, InputProps, { inputRef: inputRef, className: "DatePicker__input", onClick: handleInputClick, shortLabel: react_1.default.createElement(__1.Icon, { name: "event", className: "DatePicker__icon", onClick: handleClickIcon }), fluid: true })) }, rest), CustomCalendar ? (react_1.default.createElement(CustomCalendar, __assign({}, CalendarProps))) : (react_1.default.createElement(kendo_react_dateinputs_1.Calendar, __assign({}, CalendarProps)))));
});
//# sourceMappingURL=DatePicker.js.map